module.exports = __webpack_public_path__ + "static/media/channel-background-mobile.a1b18269.png";